<template>
  <div
    class="country-card card-condition connection-type"
    :class="{
      noteq: value === 'NOT_UNIQUE',
      'card-condition__planLimits': hasPlanLimitsRestriction('uniqOfferViewerCondition'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('uniqOfferViewerCondition')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close"></ui-icon>
    <ui-radio-group style-type="inline" v-model="value" :label="t('Conversion Type')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="NOT_UNIQUE" :label="t('Is Recurring')" />
        <ui-radio class="ml-16" value="UNIQUE" :label="t('Is Not Recurring')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'uniqOfferViewer',
  defaultValue: 'UNIQUE',
  planLimitsKey: 'uniqOfferViewerCondition',
});
</script>

<style lang="scss"></style>
